import { h } from "preact";

import IconProps from "./IconProps";

function IconUnpin({ color, width, height, class: cssClass }: IconProps) {
    return (
        <svg width={width}
            height={height}
            class={cssClass}
            viewBox="0 0 24 24">
            <path fill={color}
                d="M4.807 4.605l.047.042 14.5 14.499c.195.195.195.512 0 .707-.18.18-.465.195-.661.042l-.047-.042-14.5-14.499c-.195-.195-.195-.512 0-.707.18-.18.465-.195.661-.042zm1.135 3.543c.194.196.193.513-.003.708-.56.557-.583 1.462-.066 2.048l.068.071 7.079 7.085c.585.585 1.54.585 2.125 0 .196-.196.513-.196.708 0 .196.195.196.512 0 .708-.947.947-2.47.975-3.451.086l-.09-.087-3.197-3.2c-.016.037-.037.072-.062.104l-.043.049-4.129 4.129c-.201.201-.528.201-.73 0-.186-.186-.2-.479-.043-.681l.043-.05 4.13-4.128c.044-.045.096-.08.15-.105l-3.197-3.2c-.979-.972-.979-2.568 0-3.54.196-.194.513-.193.708.003zM16.26 4.662l.093.088 2.897 2.897c.97.97 1 2.53.088 3.535l-.088.092-2.897 2.897c-.202.202-.529.202-.73 0-.186-.186-.2-.478-.043-.68l.043-.05 2.897-2.897c.573-.573.596-1.493.069-2.093l-.069-.074-2.897-2.897c-.573-.573-1.493-.596-2.094-.069l-.073.069-1.043 1.042 2.79 2.79c.202.202.202.529 0 .73-.185.186-.478.2-.68.043l-.05-.043-2.79-2.791-1.124 1.126c-.202.202-.529.202-.73 0-.186-.186-.2-.479-.043-.681l.043-.049 2.897-2.897c.97-.97 2.529-1 3.534-.088z"/>
        </svg>
    );
}

IconUnpin.defaultProps = {
    color: "var(--peach)",
    width: 24,
    height: 24
};

export default IconUnpin;
